<template>
    <div class="box">
        <Header></Header>
      <!--公司简介-->
        <section>
            <img style="width: 100%;height: 150px;" :src="banner.path" alt="">
            <div class="nav" style="padding: 0 10px;margin-top: 10px;">
                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;margin-top: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? titleName[0] : titleEng[0]}}</p>
                <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces == 1 ? aboutUsWhat[0] : aboutUsWhatEng[0]}}</p>
                <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces == 1 ? aboutUsWhat[1] : aboutUsWhatEng[1]}} </p>
                <p style="font-size: 14px;color:#909090;padding-top: 20px;padding-bottom: 50px;">{{typefaces == 1 ? aboutUsWhat[2] : aboutUsWhatEng[2]}}</p>

              <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? titleName[1] : titleEng[1]}}</p>
              <img v-if="typefaces==1" style="width: 100%;height: auto;margin-top: 20px;" src="../../../img/yj/22.png" alt="">
              <img v-if="typefaces==2" style="width: 100%;height: auto;margin-top: 20px;" src="../../../img/yj/22s.png" alt="">

              <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;margin-top:30px;margin-bottom:10px;">{{typefaces == 1 ? titleName[2] : titleEng[2]}}</p>
              <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:25%;color:#141414;font-weight: bold;">{{typefaces == 1 ? ideaTitleName[0] : ideaTitleEng[0]}}</span><span style="color:#5B5B5B;width:75%;">{{typefaces == 1 ? ideaTextName[0] : ideaTextEng[0]}}</span></p>
              <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:25%;color:#141414;font-weight: bold;">{{typefaces == 1 ? ideaTitleName[1] : ideaTitleEng[1]}}</span><span style="color:#5B5B5B;width:75%;">{{typefaces == 1 ? ideaTextName[1] : ideaTextEng[1]}}</span></p>
              <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:25%;color:#141414;font-weight: bold;">{{typefaces == 1 ? ideaTitleName[2] : ideaTitleEng[2]}}</span><span style="color:#5B5B5B;width:75%;">{{typefaces == 1 ? ideaTextName[2] : ideaTextEng[2]}}</span></p>
              <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:25%;color:#141414;font-weight: bold;">{{typefaces == 1 ? ideaTitleName[3] : ideaTitleEng[3]}}</span><span style="color:#5B5B5B;width:75%;">{{typefaces == 1 ? ideaTextName[3] : ideaTextEng[3]}}</span></p>
              <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:25%;color:#141414;font-weight: bold;">{{typefaces == 1 ? ideaTitleName[4] : ideaTitleEng[4]}}</span><span style="color:#5B5B5B;width:75%;">{{typefaces == 1 ? ideaTextName[4] : ideaTextEng[4]}}</span></p>

              <!-- border-bottom:1px solid #E7E7E7;padding-bottom:20px;
              <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:44%;color:#141414;font-weight: bold;">Enterprise Spirit：</span><span style="color:#5B5B5B;width:56%;">Never give up, Never stop.</span></p>
              <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:44%;color:#141414;font-weight: bold;">Honest Notion：</span><span style="color:#5B5B5B;width:56%;">Honest and Clean , Prudent and Law-abiding.</span></p>
              <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:44%;color:#141414;font-weight: bold;">Talent Philosophy：</span><span style="color:#5B5B5B;width:56%;">People-oriented, Talent-orien ted.</span></p>
              <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:44%;color:#141414;font-weight: bold;">Enterprise Vision：</span><span style="color:#5B5B5B;width:56%;">To become the industry leader in China's coal transportation.</span></p>
              <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:44%;color:#141414;font-weight: bold;">Corporate mission：</span><span style="color:#5B5B5B;width:56%;">To develop enterprises. Cont ribute to the country. Serve the community. The benefit of staff.</span></p> -->

              <p style="border-left: 3px solid #BB1E10;margin-top:30px;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? titleName[3] : titleEng[3]}}</p>
              <img v-if="typefaces==1" style="width: 100%;height: auto;margin-top: 20px;" src="../../../img/yj/11.png" alt="">
              <img v-if="typefaces==2" style="width: 100%;height: auto;margin-top: 20px;" src="../../../img/yj/11s.png" alt="">
            </div>

            <Footer :typeFaces="typeFacesNumber" ></Footer>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import Header from '../Header';
import Footer from '../Footer';

export default {
	name: 'companyProfile',
	components: {
		Header,
        Footer
	},
	data () {
		return {
            titleName: ['公司简介','发展历程','企业理念','荣誉业绩'],
            titleEng: ['Company Introduction','Development History','Company  Vision','Awards'],
            /*aboutUsWhat:
                ['公司始建于内蒙古自治区甘其毛都口岸，是甘其毛都口岸涉外运输企业之一。经过十余年的快速发展，为了适应市场发展趋势和企业发展需要，' +
                '2016年正式组建成立了内蒙古子拓国际贸易有限责任公司(以下简称“子拓公司”)' +
                '子拓公司围绕煤炭上、下游产业链，创建了集煤炭产、购、运、销一体化的综合运行体系，成为内蒙古自治区重的煤炭民营企业之一。在企业发展过程中，我们一直秉承“以实力开拓市场、以信誉维系客户，实现企业经济健康增长”的经营理念和宗旨 ' +
                '不断进取,在创造经济效益的同时也创造了显著的社会效益作为一家快速发展的煤炭贸易和运输综合性民营企业，在与众多国内大型机构合作的过程中，子拓的工作方式、方法以及企业经营理念得到了广泛认可，' +
                '树立了业内良好口碑为今后继续扩大中蒙两国间的煤炭贸易和运输领域奠定了坚实的基础。'],*/
            aboutUsWhat:
                ['公司始建于内蒙古自治区甘其毛都口岸，在2011年成立了乌拉特中旗铖源贸易有限责任公司，是中蒙两国具备双方认证的贸易和运输企业，经过多年的市场快速发展和企业发展的需要，于2016年正式组建成立了内蒙古子拓国际贸易有限责任公司。 ' +
                '公司通过煤炭全产业链、探索多元化发展，坚持“以新取胜、以信求远”的经营理念，倡导“诚实守信、优质满意、互利互赢”的企业精神，实现管理规范化、体系标准化，企业在创造经济效益的同时也创造了显著的社会效益。 ' +
                '公司在煤炭贸易业务领域中集成了一套集煤炭生产、采购、运输、销售为一体的综合运营体系，在与蒙古国原煤矿区、海关监管部门的合作中签订了长期战略合作协议，为今后继续扩大中蒙两国间的煤炭贸易和运输领域奠定了坚实的基础。 ' +
                '在未来发展道路上，公司将不断探索煤炭供应链资源整合，依托大数据运用和分析，形成可持续发展的规范、高效、环保的健康发展态势，成为我国内外运销行业的领导者。'],
            /*aboutUsWhatEng:
                ['The company was founded at Ganqi Maodu Port in Inner Mongolia Autonomous Region and is one of the foreign-related transportation enterprises at Ganqi Maodu Port.\n' +
                'After more than ten years of rapid development, in order to adapt to market trends and enterprise development needs, Inner Mongolia Zituo International Trade Co., Ltd. (hereinafter referred to as "Zituo Company") was officially established in 2016\n' +
                'Zituo Company has established a comprehensive operation system that integrates coal production, procurement, transportation, and sales, focusing on the upstream and downstream industrial chains of coal, and has become one of the important private coal enterprises in Inner Mongolia Autonomous Region.\n' +
                'In the process of enterprise development, we have always adhered to the business philosophy and purpose of "expanding the market with strength, maintaining customers with reputation, and achieving healthy economic growth of the enterprise"\n' +
                'Continuously striving to create economic benefits while also creating significant social benefits. As a rapidly developing private enterprise specializing in coal trade and transportation, Zituo\'s work methods, methods,\n' +
                'and business philosophy have been widely recognized in the process of cooperation with many large domestic institutions,\n' +
                'establishing a good reputation in the industry and laying a solid foundation for further expanding the coal trade and transportation field between China and Mongolia in the future.'],*/
            // developName: ['',''],
            aboutUsWhatEng:
            ['The company was founded in Ganqi Maodu Port, Inner Mongolia Autonomous Region. In 2011, Ulat Zhongqi Chengyuan Trading Co., Ltd. was established. It is a trade and transportation enterprise certified by both sides in China and Mongolia. After years of rapid market development and the needs of enterprise development, Inner Mongolia Zituo International Trade Co., Ltd. was formally established in 2016. \n' +
            'Through the whole coal industry chain, the company explores diversified development, adheres to the business philosophy of "winning with new, seeking far with letter", advocates the enterprise spirit of "honesty and trustworthiness, quality satisfaction, mutual benefit and mutual win", realizes the standardization of management and system, and creates significant social benefits while creating economic benefits. \n' +
            'In the field of coal trade, the company has integrated a comprehensive operation system integrating coal production, procurement, transportation and sales, and signed long-term strategic cooperation agreements with Mongolia\'s raw coal mining areas and customs supervision departments, laying a solid foundation for the future expansion of coal trade and transportation between China and Mongolia. \n' +
            'On the road of future development, the company will continue to explore the integration of coal supply chain resources, relying on the application and analysis of big data, to form a healthy development trend of sustainable development, standard, efficient and environmental protection, and become a leader in China\'s internal and external transportation and marketing industry.'],
            ideaTitleName: ['企业精神：',
                            '廉洁理念：',
                            '人才理念：',
                            '企业愿景：',
                            '企业使命：'],
            ideaTitleEng: ['Company Spirit',
                          'Integrity Concept',
                          'Talent concept',
                          'Corporate Vision',
                          'Corporate Mission'],
            ideaTextName: ['永不放弃、永不止步。',
                          '清白为企，慎权守法。',
                          '以人为本，唯才是用。',
                          '成为中国煤炭运销行业的领跑者。',
                          '发展企业、贡献国家、服务社会、造福员工。'],
            ideaTextEng: ['Never give up and never stop.',
                          'Be an innocent enterprise, be careful of power and abide by the law.',
                          'People oriented and appreciate talents.',
                          'Become a leader in China\'s coal transportation and marketing industry.',
                          'Develop enterprises, contribute to the country, serve the society and benefit employees.'],
            banner: {},
            typefaces: 1,
            typeFacesNumber: 0
		}
	},

    computed: {
      aaa() {
        return this.$root.TYPEFACE;
      }
    },
    watch:{
        aaa(type) {
            this.typefaces = type;
        },
    },

	mounted() {
        this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
        this.getData();
	},

	methods: {

        fatherMethod(type){
            this.typefaces = type;
            this.typeFacesNumber = type;
        },

        // 获取轮播图
		getData() {
			axios({
				url: this.url + '/content/input/fileList',
				method: 'post',
				data: {
					parentId: 0,
                    type: 11
				},
			}).then( res => {
                this.banner = res.data[0][0];
			});
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

section {
    flex: 1;
    overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/companyProfile/CompanyProfile.vue